import { styled } from "goober";

export const SearchContainer = styled("div")`
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 12px;
  gap: 8px;
  border-bottom: 0.5px solid var(--border-alpha);
`;

export const SearchInput = styled("input")`
  flex: 1;
  background: transparent;
  border: none;
  font-size: 12px;
  font-family: InterVariable;
  line-height: 16px;
  color: var(--text-primary);
  outline: none;

  &::placeholder {
    color: var(--text-primary);
    opacity: 0.3;
  }
`;
